import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import { Provider } from 'react-redux'
import 'bootstrap/dist/css/bootstrap.min.css';
import "./styles/index.scss"
import App from './App';
import reportWebVitals from './reportWebVitals';
import { theme } from './theme';
import store from './redux/store';
import { applyStoredColorScheme } from './hooks/useColorScheme';

// Antes de montar React, para que no haya un destello de tema claro.
applyStoredColorScheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}> 
        <App />
      </ThemeProvider> 
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
